import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0c014192")

_pushScopeId("data-v-0c014192")
const _hoisted_1 = { class: "cc-menu-box" }
const _hoisted_2 = {
  class: "cc-menu",
  role: "menu",
  ref: "captionMenuHolder"
}
const _hoisted_3 = {
  key: 0,
  class: "caption-radio",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("rect", {
  class: "caption-radio",
  rx: "6",
  fill: "white"
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "caption-radio",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0Z",
  fill: "#B7B7B7"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { innerHTML: `None` }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "caption-radio",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("rect", {
  class: "caption-radio",
  rx: "6",
  fill: "white"
}, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "caption-radio",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0Z",
  fill: "#B7B7B7"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", {
        class: ["caption-button", { selected: _ctx.currentCaptions.value == 'off' }],
        onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickCaption(`off`))),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickCaption(`off`))),
        "aria-label": `${_ctx.translateLabels('No Captions')} ${_ctx.currentCaptions.value == 'off' ? 'Checked' : ''}`,
        role: "menuitemradio",
        tabindex: "0"
      }, [
        _createVNode("div", null, [
          (_ctx.currentCaptions.value == `off`)
            ? (_openBlock(), _createBlock("svg", _hoisted_3, [
                _hoisted_4
              ]))
            : (_openBlock(), _createBlock("svg", _hoisted_5, [
                _hoisted_6
              ]))
        ]),
        _hoisted_7
      ], 42, ["aria-label"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtitleArray.value, (caption, i) => {
        return (_openBlock(), _createBlock("li", {
          "aria-label": `${caption.language ? _ctx.getLanguageString(caption.language) : 'English'}
                    ${_ctx.currentCaptions.value == caption.language ? 'Checked' : ''}`,
          tabindex: "0",
          class: ["caption-button", { selected: _ctx.currentCaptions.value == caption.language }],
          key: i,
          onKeypress: ($event: any) => (_ctx.clickCaption(caption.language ? caption.language : `en`)),
          onClick: ($event: any) => (_ctx.clickCaption(caption.language ? caption.language : `en`)),
          role: "menuitemradio"
        }, [
          _createVNode("div", null, [
            (_ctx.currentCaptions.value == caption.language)
              ? (_openBlock(), _createBlock("svg", _hoisted_8, [
                  _hoisted_9
                ]))
              : (_openBlock(), _createBlock("svg", _hoisted_10, [
                  _hoisted_11
                ]))
          ]),
          _createVNode("span", {
            innerHTML: caption.language ? _ctx.getLanguageString(caption.language) : 'English'
          }, null, 8, ["innerHTML"])
        ], 42, ["aria-label", "onKeypress", "onClick"]))
      }), 128))
    ], 512)
  ]))
})